if (!customElements.get('mn-sticky-purchase')) {
  customElements.define('mn-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById('shopify-section-' + this.dataset.sectionId);
      this.main = this.root?.querySelector('.m-product-form--main');
      this.form = this.main?.querySelector('form');
      this.original = this.main?.querySelector('.m-add-to-cart');
      if (!this.original || !this.form) return;
      this.action = this.querySelector('[data-mn-add]');
      this.choice = this.querySelector('[data-mn-choice]');
      this.products = JSON.parse(this.root.querySelector('#productData')?.textContent || '{}');
      this.refresh = () => {
        const id = this.main.querySelector('[name="id"]')?.value;
        const variant = this.products.variants?.find(v => String(v.id) === String(id));
        const qty = this.main.querySelector('[name="quantity"]')?.value || '1';
        const money = variant ? new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'}).format(variant.price / 100) : '';
        const choiceText = [variant?.title === 'Default Title' ? '' : variant?.title, qty > 1 ? '× ' + qty : '', money.replace(/<[^>]*>/g, '')].filter(Boolean).join(' · ');
        if (this.choice.textContent !== choiceText) this.choice.textContent = choiceText;
        const disabled = this.original.disabled || this.original.classList.contains('disabled') || this.original.classList.contains('m-spinner-loading') || !variant?.available;
        if (this.action.disabled !== disabled) this.action.disabled = disabled;
        const actionText = this.original.querySelector('.m-add-to-cart--text')?.textContent.trim() || this.original.textContent.trim();
        if (this.action.textContent !== actionText) this.action.textContent = actionText;
      };
      this.show = () => {
        const allowed = matchMedia('(max-width: 767px)').matches ? this.dataset.mobile === 'true' : this.dataset.desktop === 'true';
        this.hidden = !allowed || this.main.getBoundingClientRect().bottom > 0;
        document.documentElement.style.setProperty('--mn-sticky-space', this.hidden ? '0px' : this.offsetHeight + 'px');
      };
      this.querySelector('[data-mn-edit]').addEventListener('click', () => {
        const info = this.root.querySelector('.m-main-product--info') || this.main;
        info.scrollIntoView({behavior:'smooth', block:'center'});
        const target = info.querySelector('input:not([type="hidden"]),select,button');
        target?.focus({preventScroll:true});
      });
      this.action.addEventListener('click', () => {
        this.refresh();
        if (this.action.disabled) return;
        if (!this.form.reportValidity()) { this.main.scrollIntoView({behavior:'smooth',block:'center'}); return; }
        this.original.click();
        const invalid = this.root.querySelector('[aria-invalid="true"],.m-product-form-message:not(:empty)');
        if (invalid) invalid.scrollIntoView({behavior:'smooth',block:'center'});
      });
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.main, {subtree:true,childList:true,attributes:true,characterData:true});
      this.root.addEventListener('change', this.refresh);
      this.root.addEventListener('input', this.refresh);
      window.addEventListener('scroll', this.show, {passive:true});
      window.addEventListener('resize', this.show);
      this.refresh(); this.show();
      this.unsubscribe = window.MinimogEvents?.subscribe(this.dataset.productId + '__VARIANT_CHANGE', () => requestAnimationFrame(this.refresh));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.root?.removeEventListener('change',this.refresh);
      this.root?.removeEventListener('input',this.refresh);
      window.removeEventListener('scroll',this.show);
      window.removeEventListener('resize',this.show);
      if(typeof this.unsubscribe === 'function') this.unsubscribe();
      document.documentElement.style.removeProperty('--mn-sticky-space');
    }
  });
}
